import moment from 'moment-timezone'
import queryString from 'query-string'
import { FORMATS } from 'constants/datetime'
import { EXPIRATION_DAYS } from '../constants/detention'

export const parseExpirationTime = search => {
  const query = queryString.parse(search)
  const expiresAt = query.expires_at || ''
  return expiresAt
}

export const formatExpirationTime = expiresAt => {
  const now = moment().toISOString()
  const difference = moment(expiresAt, FORMATS.iso8601Format).diff(
    moment(now, FORMATS.iso8601Format)
  )
  const duration = moment.duration(difference)
  const expirationTime = Math.floor(duration.asHours()) + moment(difference).format(':mm:ss')
  return expirationTime
}

export const isExpired = expiresAt => {
  const now = moment().toISOString()
  const difference = moment(expiresAt, FORMATS.iso8601Format).diff(
    moment(now, FORMATS.iso8601Format)
  )
  return difference <= EXPIRATION_DAYS
}
